// Lightweight sound effects using Web Audio API — no external assets required.
// Persists mute preference in localStorage under `akm_sound_muted`.

const MUTED_KEY = "akm_sound_muted";
let audioCtx = null;

function getContext() {
    if (audioCtx) return audioCtx;
    if (typeof window === "undefined") return null;
    const Ctor = window.AudioContext || window.webkitAudioContext;
    if (!Ctor) return null;
    try { audioCtx = new Ctor(); } catch { audioCtx = null; }
    return audioCtx;
}

export function isMuted() {
    try { return localStorage.getItem(MUTED_KEY) === "1"; } catch { return false; }
}

export function setMuted(muted) {
    try { localStorage.setItem(MUTED_KEY, muted ? "1" : "0"); } catch { /* ignore */ }
}

/**
 * Play a soft two-tone "ding" — an E5 to A5 pair meant to be gentle but noticeable.
 * Safely no-ops when the tab has no user gesture yet or the browser blocks it.
 */
export function playDing() {
    if (isMuted()) return;
    const ctx = getContext();
    if (!ctx) return;
    // Some browsers create the context in "suspended" state until a user gesture.
    if (ctx.state === "suspended") {
        try { ctx.resume(); } catch { /* ignore */ }
    }

    const now = ctx.currentTime;
    // Master gain — kept low so the ding is soft, not startling.
    const master = ctx.createGain();
    master.gain.setValueAtTime(0.0001, now);
    master.gain.exponentialRampToValueAtTime(0.18, now + 0.02);
    master.gain.exponentialRampToValueAtTime(0.0001, now + 0.9);
    master.connect(ctx.destination);

    const play = (freq, start, dur) => {
        const osc = ctx.createOscillator();
        osc.type = "sine";
        osc.frequency.setValueAtTime(freq, now + start);
        const g = ctx.createGain();
        g.gain.setValueAtTime(0.0001, now + start);
        g.gain.exponentialRampToValueAtTime(1.0, now + start + 0.015);
        g.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
        osc.connect(g);
        g.connect(master);
        osc.start(now + start);
        osc.stop(now + start + dur + 0.05);
    };

    // Two-tone: E5 (659.25 Hz) then A5 (880 Hz). Second tone slightly quieter.
    play(659.25, 0.0, 0.35);
    play(880.0, 0.18, 0.45);
}
